<template>
  <div class="modal fade" id="addChangeModal" tabindex="-1" role="dialog" aria-labelledby="addChangeModalLabel" aria-hidden="true">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="addChangeModalLabel">Lorem Ipsum</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label class="custom-label">Date</label>
            <datepicker
              format="dd.MM.yyyy"
              :value="change.date"
              @input="change.date = $event"
              :bootstrap-styling="true"
              input-class="bg-white"
            />
          </div>
          <div class="form-group">
            <label class="custom-label">Additional Equipment Placed</label>
            <br>
            <textarea class="form-control" v-model="change.printers"></textarea>
          </div>
          <div class="form-group">
            <label class="custom-label">Changed Business Case Period</label>
            <br>
            <textarea class="form-control" v-model="change.contract"></textarea>
          </div>
        </div>
        <div class="modal-footer" style="justify-content: space-between;">
          <button type="button" class="btn btn-primary" @click="storeChange">Add</button>
          <button type="button" class="btn btn-warning" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import moment from 'moment'

  export default {
    props: ['rollOutId'],
    data() {
      return {
        change: {
          date: new Date,
          printers: '',
          contract: '',
        }
      }
    },
    methods: {
      storeChange() {
        window.axios.post(`/roll_outs/${this.rollOutId}/changes`, {
          date: this.change.date ? moment(this.change.date).format('YYYY-MM-DD') : '',
          printers: this.change.printers,
          contract: this.change.contract,
        }).then(({data}) => this.$emit('changeAdded', data))
      },
    },
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// resources/js/components/roll_outs/AddChangeModal.vue